import { EntityType } from '@repo/common/enums/entityType';
import type { CustomPropertyTypeValue } from './types';

export const CUSTOM_PROPERTY_TYPE_OPTIONS: Array<{
	value: CustomPropertyTypeValue;
	label: string;
}> = [
	{ value: 'string', label: 'Text' },
	{ value: 'number', label: 'Number' },
	{ value: 'boolean', label: 'Checkbox' },
	{ value: 'date', label: 'Date' },
	{ value: 'select', label: 'Dropdown' },
	{ value: 'tag', label: 'Tag' },
	{ value: 'resource', label: 'Resource' },
	{ value: 'user', label: 'User' },
];

export const CUSTOM_PROPERTY_TYPE_MAP: Record<CustomPropertyTypeValue, string> =
	{
		string: 'Text',
		number: 'Number',
		boolean: 'Checkbox',
		date: 'Date',
		select: 'Dropdown',
		tag: 'Tag',
		resource: 'Resource',
		user: 'User',
	};

export const CUSTOM_PROPERTY_ICON_HEIGHT = 20;

export const CUSTOM_PROPERTY_VISIBILITY_ENTITY_TYPES: EntityType[] = [
	EntityType.table,
	EntityType.column,
	EntityType.collection,
	EntityType.glossary,
	EntityType.document,
	EntityType.question,
	EntityType.test,
	EntityType.dashboard,
	EntityType.dashboard_group,
	EntityType.job,
	EntityType.job_group,
];

export const CUSTOM_PROPERTY_ERROR_MESSAGES = {
	LABEL_ALREADY_EXISTS: 'A column with this name already exists',
	LABEL_INVALID:
		'Label must be alphabetical characters, numbers, underscores, and hyphens',
	LABEL_REQUIRED: 'Label is required',
	TYPE_REQUIRED: 'A type selection is required',
};

export const CUSTOM_PROPERTY_FORM_FIELDS = ['label', 'type', 'visibility'];
